<script setup lang="ts">
	import { cn } from '@/helpers/cn'

	interface Props {
		class?: string
	}

	const props = defineProps<Props>()
</script>

<template>
	<tbody :class="cn('bg-white divide-y divide-gray-200', props.class)">
		<slot />
	</tbody>
</template>
